import { inject, Injectable } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';

@Injectable({ providedIn: 'root' })
export class TableService {
  private firebaseService = inject(FirebaseService);

 async onLoadPage(event: any, tableRef: any): Promise<void> {
  try {
    this.firebaseService.setPath(event.path);
    const result = await this.firebaseService.loadPage(event.path, event.pageSize, event.lastDoc);
    
    // Update all the necessary properties
    tableRef.data = result.data;
    tableRef.lastDoc = result.lastDoc;
    tableRef.hasMore = result.hasMore;  // ✅ This is crucial!
    tableRef.loading = false;
    
    // Update display indices after setting data
    if (tableRef.totalRecords > 0) {
      tableRef.updateDisplayIndices();
    }
    
    console.log('✅ [TableService] Updated table state:', {
      dataLength: tableRef.data.length,
      hasMore: tableRef.hasMore,
      totalRecords: tableRef.totalRecords,
      currentPage: tableRef.currentPage
    });
    
  } catch (error) {
    console.error('Error loading page:', error);
    tableRef.loading = false;
    tableRef.error = error instanceof Error ? error.message : 'Failed to load data';
  }
}

  async onGetTotal(event: any, tableRef: any): Promise<void> {
  try {
    const totalRecords = await this.firebaseService.getTotal(event.path);
    tableRef.totalRecords = totalRecords;
    
    // Always update display indices after setting total
    tableRef.updateDisplayIndices();  // ✅ Always call this
    
    console.log('📊 [TableService] Total records set:', totalRecords);
  } catch (error) {
    console.error('Error getting total:', error);
    tableRef.error = 'Failed to get total record count';
  }
}

  async onAdd(event: any): Promise<void> {
    try {
      await this.firebaseService.add(event.path, event.item);
    } catch (error) {
      console.error('Error adding document:', error);
    }
  }

  async onUpdate(event: any): Promise<void> {
    try {
      await this.firebaseService.update(event.id, event.data);
    } catch (error) {
      console.error('Error updating document:', error);
    }
  }

  async onDelete(event: any): Promise<void> {
    try {
      await this.firebaseService.delete(event.id);
    } catch (error) {
      console.error('Error deleting document:', error);
    }
  }

  async onDeleteBatch(event: any): Promise<void> {
    try {
      await this.firebaseService.deleteBatch(event.ids);
    } catch (error) {
      console.error('Error deleting batch:', error);
    }
  }

  async onDeleteAll(): Promise<void> {
    try {
      await this.firebaseService.deleteAll();
    } catch (error) {
      console.error('Error deleting all:', error);
    }
  }

  async onUploadFile(event: any): Promise<void> {
    try {
      await this.firebaseService.uploadFile(event.path, event.file);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }

  async onImportData(event: any): Promise<void> {
    try {
      await this.firebaseService.importData(event.items);
    } catch (error) {
      console.error('Error importing data:', error);
    }
  }
}